import { useAuthStore } from '@/modules/auth/store/auth';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { getUser } = useAuthStore();

  if (getUser.role !== 'INTERNAL_HEALTH_PROFESSIONAL' && getUser.role !== 'HEALTH_OFFICER') {
    return navigateTo('/');
  }
});
